/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* components */
import SalesforceTestDrive from './components/SalesforceTestDrive';

/* utilities */
import { parseDataToProps } from '~/utilities';

const SalesforceTestDriveNodes = Array.from(document.querySelectorAll('.salesforce-test-drive'));
[...SalesforceTestDriveNodes].forEach((node) => render(<SalesforceTestDrive {...parseDataToProps(node.dataset)} />, node));
